import { addParamsToUrl } from "@zapier/url-utils";

import { Interval } from "@zapier/checkout/esm/types";

/**
 * The currentPlanName prop isn't necessary anymore, but it's left in for
 * backwards compatability reasons.
 */
export const buildUpgradeUrl = (
  currentPlanName: string | null | undefined,
  upgradeToPlanName: string,
  interval: Interval,
  selectedCurrency?: string
) => {
  const url = upgradeToPlanName
    ? encodeURI(
        `/app/billing/plans/upgrade/${
          currentPlanName ? `${currentPlanName.toLowerCase()}/` : ""
        }${upgradeToPlanName.toLowerCase()}?interval=${interval}`
      )
    : "";

  return url
    ? addParamsToUrl(url, { currency: selectedCurrency }, true)
    : undefined;
};
